import { Injectable } from '@angular/core';
import { Company } from '../interfaces/company';
import { UserService } from './user.service';
import { CompanyService } from './company.service';

@Injectable({ providedIn: 'root' })
export class CompanyAccessService {
  constructor(
    private userService: UserService,
    private companyService: CompanyService
  ) {}

  public isCompanyOutsideUserAccess(companyId: string): boolean {
    if (this.userService.isCurrentUserGlobal()) return false;

    const userCompanies = this.getCompanies();
    if (!userCompanies.length) return false;

    return !userCompanies.some((company) => company.companyId === companyId);
  }

  private getCompanies(): Company[] {
    return (this.companyService?.getCompanies() || []).filter(
      (c) => c.companyName && c.companyId
    );
  }
}
